module.exports = __webpack_public_path__ + "static/media/icon-payment-tip-error.b759c861.svg";